export const FILTER_TYPES = [
  { id: "contains", label: "Contains" },
  { id: "doesNotContain", label: "Does not contain" },
  { id: "is", label: "Is" },
  { id: "isNot", label: "Is not" },
  { id: "isEmpty", label: "Is empty" },
  { id: "isNotEmpty", label: "Is not empty" },
] as const

export type FilterTypeId = (typeof FILTER_TYPES)[number]["id"]

export interface ColumnFilterValue {
  type: FilterTypeId
  value?: string
}

export const PAGE_SIZES = [10, 25, 50, 100, 250]

// --- Number format (for number/integer columns) ---
export const STYLE_OPTIONS = [
  { id: "normal", label: "Normal" },
  { id: "percent", label: "Percent" },
  { id: "scientific", label: "Scientific" },
  { id: "currency", label: "Currency" },
] as const

export const SEPARATOR_OPTIONS = [
  { id: "100,000.00", label: "100,000.00", thousands: ",", decimal: "." },
  { id: "100 000,00", label: "100 000,00", thousands: " ", decimal: "," },
  { id: "100.000,00", label: "100.000,00", thousands: ".", decimal: "," },
  { id: "100000.00", label: "100000.00", thousands: "", decimal: "." },
  { id: "100'000.00", label: "100'000.00", thousands: "'", decimal: "." },
] as const

export type NumberStyleId = (typeof STYLE_OPTIONS)[number]["id"]
export type SeparatorStyleId = (typeof SEPARATOR_OPTIONS)[number]["id"]

export interface NumberFormatConfig {
  style: NumberStyleId
  separatorStyle: SeparatorStyleId
  decimalPlaces: number
  multiplyBy: number
  prefix: string
  suffix: string
  align: "left" | "right"
}

export const DEFAULT_NUMBER_FORMAT: NumberFormatConfig = {
  style: "normal",
  separatorStyle: "100,000.00",
  decimalPlaces: 2,
  multiplyBy: 1,
  prefix: "",
  suffix: "",
  align: "left",
}

export interface ContainerFieldForTable {
  id: string
  field_name: string
  field_path: string
  display_name?: string
}
